import { render, staticRenderFns } from "./ProofreadingPopup.vue?vue&type=template&id=cb00050e&scoped=true"
import script from "./ProofreadingPopup.vue?vue&type=script&lang=ts"
export * from "./ProofreadingPopup.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingPopup.vue?vue&type=style&index=0&id=cb00050e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb00050e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb00050e')) {
      api.createRecord('cb00050e', component.options)
    } else {
      api.reload('cb00050e', component.options)
    }
    module.hot.accept("./ProofreadingPopup.vue?vue&type=template&id=cb00050e&scoped=true", function () {
      api.rerender('cb00050e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/ProofreadingPopup.vue"
export default component.exports